@import "../../../variables.scss";

.basicInfo__imageText {
  position: relative;
  z-index: 5;
  color: $color-white;
  text-align: center;

  h3 {
    font-size: 1.5rem;
  }

  @media (max-width: 991px) {
    text-align: left;
    p {
      font-size: 1.3rem;
    }
    h3 {
      font-size: 1.4rem;
    }
  }
}

.basicInfo__image {
  position: absolute;
  left: -35px;
  bottom: -394px;
  @media (max-width: 1200px) {
    bottom: -394px;
  }
}

.basicInfo__imageBackground {
  position: relative;
  @media (max-width: 991px) {
    margin-bottom: 30px;
    padding: 0;
  }
}

.basicInfo__imageBackground:after {
  content: "";
  width: 2032px;
  height: 1296px;
  background-color: $color-background-blue;
  position: absolute;
  left: -278%;
  top: -541px;
  border-radius: 50%;

  @media (max-width: 1200px) {
    left: -350%;
  }
  @media (max-width: 991px) {
    left: -44%;
    top: -75%;
    width: 200%;
    height: 193%;
  }
}

.basicInfo__actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  button,
  a {
    width: 140px;
    &:hover {
      text-decoration: none;
    }
  }
}

.basicInfo__actionsWrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.basicInfo__skip {
  border: 1px solid $color-orange;
  color: $color-grey;
  margin-left: 30px;
}

.basicInfo__rowDate {
  width: 350px;
}

.basicInfo__form {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 80px;
  @media (max-width: 991px) {
    padding: 0;
  }
}

.basicInfo__form_container {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.nationality {
  width: 185px;
}
